export default "__VITE_ASSET__zJFVCK5e__"